<template>
  <div class="">
    <Line :data="fondsStore.lineChartConfig" :options="theOptions" />
  </div>
</template>

<script setup lang="ts">
import {
  Chart as ChartJS,
  CategoryScale,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Filler
} from 'chart.js'

import { Line } from 'vue-chartjs'
import { options } from '@/components/ChartConfig/LineChartConfig'
import { useFondsStore } from '@/stores/fonds'
import { ref } from 'vue'
const fondsStore = useFondsStore()

const theOptions = ref(options)

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)
</script>
